import '.ay{width:100vw;}.ssr-plugin'
import '.az{min-height:100dvh;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.b0{height:124px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.a{padding:24px;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.b2{display:grid;}.ssr-plugin'
import '.b3{grid-template-columns:1fr;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.b4{justify-items:center;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.b6{grid-column:1;}.ssr-plugin'
import '.b7{grid-row:1;}.ssr-plugin'
import '.b8{align-self:center;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'
import { StepOne } from './StepOne.js'
import { StepTwo } from './StepTwo.js'
import { Logo } from '../../assets/svg/Logo.js'
import { Stepper } from '../../components/Stepper.js'
import { IconButton } from '../../components/IconButton.js'
import { Icon } from '../../assets/icons/index.js'
import { StepThree } from './StepThree.js'
import { StepFour } from './StepFour.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { useSelectedVotingRegion } from '../../hooks/useSelectedVotingRegion.js'
import { MenuVotingRegion } from '../../components/MenuVotingRegion.js'
import { SelectLanguageModal } from '../../components/SelectLanguageModal.js'
import { SelectVotingRegionModal } from '../../components/SelectVotingRegionModal.js'
import {
  STEP_SLIDE_DURATION_MS,
  STEP_SLIDE_IN_LEFT,
  STEP_SLIDE_IN_RIGHT,
  STEP_SLIDE_OUT_LEFT,
  STEP_SLIDE_OUT_RIGHT,
} from '../../utils/animations.js'
import { MOBILE } from '../../utils/breakpoints.js'
import { PrivacyModal } from '../../components/PrivacyModal.js'
import { useDictionary } from '../../hooks/useDictionary.js'

const renderStep = (
  s: number,
  step: number,
  setStep: (n: number) => void,
  dictionary: any,
  setOpenLangSelectModal: any,
  setOpenRegionModal: any,
  setPrivacyModal: (x: boolean) => void,
) => {
  if (s === 0)
    return (
      <StepOne
        step={step}
        setStep={setStep}
        dictionary={dictionary}
        setOpenLangSelectModal={setOpenLangSelectModal}
        setOpenRegionModal={setOpenRegionModal}
      />
    )
  if (s === 1)
    return <StepTwo step={step} setStep={setStep} dictionary={dictionary} />
  if (s === 2)
    return <StepThree step={step} setStep={setStep} dictionary={dictionary} />
  if (s === 3)
    return (
      <StepFour dictionary={dictionary} setPrivacyModal={setPrivacyModal} />
    )
  return null
}

export const OnBoardingPage = () => {
  const [step, setStep] = useState(0)
  const [prevStep, setPrevStep] = useState<number | null>(null)
  const [direction, setDirection] = useState<'forward' | 'backward'>('forward')
  const [privacyModal, setPrivacyModal] = useState(false)

  const track = useTrack('onboarding')
  const [selectedRegion] = useSelectedVotingRegion()

  const goToStep = (next: number) => {
    if (next === step) return
    setDirection(next > step ? 'forward' : 'backward')
    setPrevStep(step)
    setStep(next)
  }

  useEffect(() => {
    if (prevStep === null) return
    const t = setTimeout(() => setPrevStep(null), STEP_SLIDE_DURATION_MS)
    return () => clearTimeout(t)
  }, [prevStep, step])

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  const [openLangMenu, setOpenLangMenu] = useState(false)
  const [openLangSelectModal, setOpenLangSelectModal] = useState(false)
  const [openRegionModal, setOpenRegionModal] = useState(false)

  const dictionary = useDictionary()

  return (
    <>
      <div className="ay az ai"
      >
        <nav className="ai b0 m a b1 e ao"
          id="onboarding-nav-content"
        >
          <IconButton
            ariaLabel="step-back"
            id="onboarding-nav-action-back-button"
            icon={<Icon type="backIcon" />}
            style={{
              opacity: step === 0 ? 0 : 1,
              pointerEvents: step === 0 ? 'none' : 'auto',
            }}
            onClick={() => goToStep(step - 1)}
          />
          <div>
            <Logo style={{ marginBottom: 48 }} width={95} height={32} />
            {selectedRegion !== 'SM' && (
              <Stepper currentStep={step + 1} steps={4} />
            )}
          </div>
          <IconButton
            ariaLabel="open-language-menu"
            id="onboarding-nav-action-menu-button"
            icon={<Icon type="globeIcon" style={{ pointerEvents: 'none' }} />}
            onClick={() => {
              setOpenLangMenu(!openLangMenu)
            }}
          />
        </nav>

        <div className="b2 b3 w b4 m b5"
          key={selectedRegion}
        >
          {prevStep !== null && (
            <div className="b6 b7 b8 ar"
              key={`prev-${prevStep}`}
              style={{
                animation:
                  direction === 'forward'
                    ? STEP_SLIDE_OUT_LEFT
                    : STEP_SLIDE_OUT_RIGHT,
              }}
            >
              {renderStep(
                prevStep,
                prevStep,
                goToStep,
                dictionary,
                setOpenLangSelectModal,
                setOpenRegionModal,
                setPrivacyModal,
              )}
            </div>
          )}
          <div className="b6 b7 b8"
            key={`cur-${step}`}
            style={{
              animation:
                direction === 'forward'
                  ? STEP_SLIDE_IN_RIGHT
                  : STEP_SLIDE_IN_LEFT,
            }}
          >
            {renderStep(
              step,
              step,
              goToStep,
              dictionary,
              setOpenLangSelectModal,
              setOpenRegionModal,
              setPrivacyModal,
            )}
          </div>
        </div>
      </div>
      {openLangMenu && (
        <MenuVotingRegion
          id="onboarding-nav-menu-modal"
          triggerId="onboarding-nav-action-menu-button"
          setOpen={setOpenLangMenu}
          setOpenLangSelectModal={setOpenLangSelectModal}
          setOpenRegionModal={setOpenRegionModal}
          style={{
            top: 72,
            right: 24,
            [MOBILE]: {
              top: '72px',
              left: '16px',
              right: '16px',
              maxWidth: 'unset',
              width: 'auto',
            },
          }}
        />
      )}

      {openLangSelectModal && (
        <SelectLanguageModal setModal={setOpenLangSelectModal} />
      )}

      {openRegionModal && (
        <SelectVotingRegionModal setModal={setOpenRegionModal} />
      )}

      {privacyModal && <PrivacyModal setModal={setPrivacyModal} />}
    </>
  )
}
